export { default } from "@src/Apps/TermsOfService";
